export namespace HeaderNamesConst
{
  export const MSVCToken = 'Authorization-MSVC';
}
